import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-assets-arrow-down",
  "use": "icon-assets-arrow-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-assets-arrow-down\"><path d=\"M156.16 350.866286L503.296 705.097143a34.304 34.304 0 0 0 49.005714 0l347.209143-354.230857A34.304 34.304 0 0 0 875.008 292.571429H180.662857c-30.427429 0-45.787429 36.571429-24.502857 58.294857z\" p-id=\"4578\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol